import { useMemo } from 'react';
import { useStandardExams } from 'store/standardexams';

const useStandardExam = () => {
  const allStandardExam = useStandardExams();
  const standardExam = allStandardExam.sort((a, b) => Number(a.order) - Number(b.order));

  const standardExamBooks = useMemo(() => {
    return standardExam.map((exam) => exam.standard_exams).flat();
  }, [standardExam])


  const basedOnGradeStandardExam = (grade) => {
    return standardExam.find((exam) => exam.displayName === grade)?.standard_exams || [];
  };

  return {
    allStandardExam,
    standardExam,
    basedOnGradeStandardExam,
    standardExamBooks
  };
};

export default useStandardExam;
